export default "__VITE_ASSET__4fEXN0cL__"